// extracted by mini-css-extract-plugin
module.exports = {"label":"Y2LmIOIc8I-CTaukoz-lH","icon":"_1iywwlp5Y10T3Ir1KJT_aQ","labelText":"_2uNesOTm0XUObp-n6yaXF8"};